export default "__VITE_ASSET__38oph4NS__"